import React from "react"
import styled from "styled-components"
import GlobalStyles from "../styles/GlobalStyles"
import Typography from "../styles/Typography"
import Header from "./Header"
import Footer from "./Footer"

const Wrapper = styled.div`
  position: relative;
  min-height: 100vh;
`
const FooterStyle = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
`
const ChildrenStyle = styled.div`
  border: 1px solid white;
  height: 100%;
`
const ContentStyle = styled.div`
  width: 92%;
  margin: 100px auto 0;
  
`;

const Layout = ({ children }) => {
  return (
    <Wrapper>
      <GlobalStyles />
      <Typography />
      <Header />
      <ChildrenStyle>
        <main><ContentStyle>{children}</ContentStyle></main>
     
      </ChildrenStyle>
      <FooterStyle>
        <Footer />
      </FooterStyle>
    </Wrapper>
  )
}

export default Layout
